<div> 
  <header>
    <div class="header-left">
      <img src="assets/img/logo_cctb2.svg" class="logo-cctb-header me-3 ">
      <h2>&nbsp;&nbsp;Botões de Alerta</h2>
    </div>
    <div class="header-right">
      <div class="clock" (click)="randomAlert()">{{pHour}}</div>
    </div>
  </header>

  <main>
    <div class="left-section">
      <div class="toggle-link div1" (click)="rightSectionONOFF()" *ngIf="!rightSectionVisible"><i class="bi bi-chevron-left"></i> ver registos</div>
      <div class="toggle-link div2" (click)="rightSectionONOFF()" *ngIf="rightSectionVisible"><i class="bi bi-chevron-right"></i> esconder registos</div>
      <div *ngFor="let n of numSequence(numberOfButtons)">
        <section>
          <h2 class="mt-2">{{translateButtonText(n.toString())}}</h2>
          <span *ngIf="rightSectionVisible" class="button-identifier">{{translateButtonIdentifier(n.toString())}}</span>
          <div class="{{buttonClass[n]}}" (click)="cancelAlert(n)"><i class="bi bi-bell-fill {{buttonIcoClass[n]}}"></i></div>
          <p *ngIf="buttonClass[n]=='ballAlert'" class="timer"><span class="timer"></span>{{timerMin[n] | number:'2.0'}}:{{timerSec[n] | number:'2.0'}}</p>
          <p *ngIf="buttonClass[n]!='ballAlert'" class="textButton"><span class="textButton"></span>{{textButton[n]}}</p>
        </section>
      </div>
    </div>



    <div class="{{rightSection}}">
      <div class="eraseBtn" (click)="eraseLogs()"><i class="bi bi-eraser-fill"></i> limpar registos</div>
        <div class="scroll-wrapper">
        <span class="scroll-start-at-top"></span>
        <div id="scroll-container">
          <span style="width: 500px;white-space: pre-line">{{logsText}}</span>
        </div>
      </div>
    </div>
  </main>    
</div>

<footer>
  <div><img src="../assets/img/logo_wgs_white.png" class="img-fluid logo-wgs"></div>
  <div class="center-area" id="status">{{statusText}}</div>
  <div><i class="bi bi-info-circle " data-bs-toggle="modal" data-bs-target="#myModal"></i></div>
</footer>

 
<!-- The Modal -->
<div class="modal" id="myModal">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-11 d-inline-flex">
              <img alt="Logo CCTB" src="assets/img/logo_cctb.png" class="img-fluid logo-cctb">
              <h3 class="modal-title ms-2">CCTB - Centro Coordenador de Transportes de Braga</h3>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
      <div class="p-3">
          <h3 class="modal-title">Sistema de Informação ao público para pessoas com deficiência visual</h3>
        </div>
        <div class="p-3 fs-1-15rem">
          Em locais estratégicos do Centro Coordenador de Transportes de Braga estão instalados botões de pedido de ajuda para pessoas com incapacidade, permitindo assim uma resposta fácil e rápida a qualquer incidente ou evento que surja no Centro Coordenador de Transportes, sejam incidentes de acessibilidade, dificuldades de embarque, pedido de emergência ou outros. Um local mais inclusivo também nos meios de pedido de ajuda aos utentes.
        </div>
        <div class="modal-image mt-4">
          <div class="row"></div>
          <img src="assets/img/logo_wgs_black.png" class="logo-wgs-footer img-fluid">
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">Wegoshare, Lda. &copy; {{ year }}</span>
        </div>
        <div class="modal-image mt-4">
          <span class="footer-text">versão {{ version }}</span>
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer p-0">
        <button #closeModal type="button" class="btn btn-danger btn-80" data-bs-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>